// custom-snackbar.component.ts
import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationElement } from '../notification.model';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-notification-alert',
  templateUrl: './notification-alert.component.html',
  styleUrl: './notification-alert.component.scss',
})
export class NotificationAlertComponent implements OnDestroy {
  private readonly autoCloseTimeoutId: any;
  private readonly autoCloseDuration = 6000;

  constructor(
    @Inject(MAT_DIALOG_DATA) public notificationData: NotificationElement,
    private readonly dialogRef: MatDialogRef<NotificationAlertComponent>,
    private readonly notificationService: NotificationService
  ) {
    this.autoCloseTimeoutId = setTimeout(() => {
      this.dialogRef.close();
    }, this.autoCloseDuration);
  }

  close(event?: any) {
    event?.stopPropagation();
    event?.preventDefault();

    this.dialogRef.close();
  }

  openNotification(event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.notificationService.openNotification(this.notificationData);
    this.close();
  }

  ngOnDestroy(): void {
    if (this.autoCloseTimeoutId) {
      clearTimeout(this.autoCloseTimeoutId);
    }
  }
}
